(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-1"] && !Shopify.designMode) return;
  try {
    
function initializeWoowindFooters() {
  document.querySelectorAll('[data-ww-footer]').forEach(footer => {
    if (footer.dataset.initialized) return;
    footer.dataset.initialized = 'true';
    const mobile = window.matchMedia('(max-width: 700px)');
    const groups = Array.from(footer.querySelectorAll('.ww-menu'));
    const update = () => groups.forEach(group => {
      group.open = !mobile.matches;
      const summary = group.querySelector('summary');
      summary.tabIndex = mobile.matches ? 0 : -1;
      summary.setAttribute('aria-disabled', String(!mobile.matches));
    });
    groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
      if (!mobile.matches) event.preventDefault();
    }));
    mobile.addEventListener('change', update);
    update();
    footer.querySelector('[data-ww-top]').addEventListener('click', event => {
      event.preventDefault();
      window.scrollTo({top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    });
  });
}
initializeWoowindFooters();
document.addEventListener('shopify:section:load', initializeWoowindFooters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
class WoowindDeferredHomeVideo extends HTMLElement {
  connectedCallback() {
    if(this.loadObserver)return;
    this.visible=false;
    this.abort=new AbortController();
    const options={signal:this.abort.signal};
    this.addEventListener('loadeddata',()=>{this.classList.add('is-ready');this.playIfVisible()}, {...options,capture:true});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)this.video?.pause();else this.playIfVisible()},options);
    if(!('IntersectionObserver' in window)){this.visible=true;this.loadVideo();return}
    this.loadObserver=new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)){this.loadVideo();this.loadObserver.disconnect()}
    },{rootMargin:'1200px 0px',threshold:0});
    this.playObserver=new IntersectionObserver(entries=>{
      this.visible=entries.some(entry=>entry.isIntersecting);
      if(this.visible)this.playIfVisible();else this.video?.pause();
    },{threshold:0.01});
    this.loadObserver.observe(this);
    this.playObserver.observe(this);
  }
  loadVideo() {
    if(this.video)return;
    const template=this.querySelector('template');
    if(!template)return;
    template.after(template.content.cloneNode(true));
    this.video=this.querySelector('video');
    if(!this.video)return;
    this.video.muted=true;
    this.video.load();
    this.playIfVisible();
  }
  playIfVisible() {
    if(this.video&&this.visible&&!document.hidden)this.video.play().catch(()=>{});
  }
  disconnectedCallback() {
    this.loadObserver?.disconnect();
    this.playObserver?.disconnect();
    this.abort?.abort();
    this.video?.pause();
    this.loadObserver=null;
  }
}
if(!customElements.get('ww-deferred-home-video'))customElements.define('ww-deferred-home-video',WoowindDeferredHomeVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woowind-hero-slider"] && !Shopify.designMode) return;
  try {
    
class WoowindRecoveredHero extends HTMLElement {
 connectedCallback(){
  this.slides=[...this.querySelectorAll('.hero-slide')];this.buttons=[...this.querySelectorAll('.slider-menu button')];this.index=0;
  this.abort=new AbortController();const options={signal:this.abort.signal};
  this.buttons.forEach((button,i)=>button.addEventListener('click',()=>{if(i!==this.index)this.show(i)},options));
  this.addEventListener('touchstart',e=>{this.touchX=e.touches[0].clientX}, {...options,passive:true});
  this.addEventListener('touchend',e=>{if(this.touchX==null)return;const dx=e.changedTouches[0].clientX-this.touchX;if(Math.abs(dx)>45)this.show(this.index+(dx<0?1:-1));this.touchX=null},options);
  this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));this.buttons[this.index].focus()}},options);
  document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.show(i);clearTimeout(this.timer)}},options);
  document.addEventListener('shopify:block:deselect',()=>this.schedule(),options);
  this.show(0);
 }
 show(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active});this.buttons.forEach((button,i)=>{button.classList.toggle('active',i===this.index);button.setAttribute('aria-pressed',String(i===this.index))});this.schedule()}
 schedule(){clearTimeout(this.timer);if(this.slides.length>1&&this.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches)this.timer=setTimeout(()=>this.show(this.index+1),6000)}
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort()}
}
if(!customElements.get('woowind-recovered-hero'))customElements.define('woowind-recovered-hero',WoowindRecoveredHero);


  } catch(e) { console.error(e); }
})();
})();
